import { WizardStep, WizardStepIndex } from "../../../shared/enums/WizardStep";
import { linkHelper } from "../../../shared/helpers/linkHelper";
import StepActive from "./StepActive";
import StepDone from "./StepDone";
import StepInactive from "./StepInactive";

interface ProductStepItemProps {
  activeStepIndex: number;
  market: string;
  text: string;
}

const ProductStepItem = ({
  activeStepIndex,
  market,
  text,
}: ProductStepItemProps) => {
  const stepNumber = WizardStepIndex.Product + 1;
  const hideMobile =
    activeStepIndex > WizardStepIndex.ContactUs &&
    activeStepIndex < WizardStepIndex.MachineTonnage
      ? ""
      : "";

  if (activeStepIndex === WizardStepIndex.Product) {
    return (
      <StepActive
        hideMobilClass={hideMobile}
        stepNumber={stepNumber}
        text={text}
      />
    );
  }

  if (activeStepIndex < WizardStepIndex.Product) {
    return (
      <StepInactive
        hideMobilClass={hideMobile}
        stepNumber={stepNumber}
        text={text}
      />
    );
  }

  const url = linkHelper.link(WizardStep.Product, market);
  return <StepDone hideMobilClass={hideMobile} text={text} url={url} />;
};

export default ProductStepItem;
